import React from "react";
import { Center } from "@react-three/drei";
import { useAnimatedText } from "../../hooks/useAnimatedText";
import Text3DComponent from "./Text3DComponent";
import { TEXT_3D_CONFIG } from "../../constants";

const MAIN_TITLE_TEXT = "Hola Friend! I'M RAGHAV";
const SUBTITLE_TEXT = "Look what I built! Grab the dart and aim to explore.";

export default function Scene() {
  const textRef = useAnimatedText();

  return (
    <Center>
      <group ref={textRef}>
        <Text3DComponent
          text={MAIN_TITLE_TEXT}
          variant="main"
          isShadow
          position={TEXT_3D_CONFIG.MAIN_TITLE.SHADOW_POSITION}
        />
        <Text3DComponent
          text={MAIN_TITLE_TEXT}
          variant="main"
          castShadow
        />
        <Text3DComponent
          text={SUBTITLE_TEXT}
          variant="subtitle"
        />
      </group>
    </Center>
  );
}

